import FormativeForm from 'components/CreateFormative/FormativeForm';
import { useTranslation } from 'react-i18next';
import { Button, Container, Icon, Stack, styled, Text } from 'shell/components';

const Desktop = ({ currentAssignment, form, setForm, errors, isLoading, onClickBack, onClickSubmit }) => {
    const { t } = useTranslation('assignment');

    return (
        <Container device={'desktop'}>
            <CustomStack spacing={5}>
                <Button
                    sx={{ alignSelf: 'flex-start' }}
                    startIcon={<Icon kind={'arrowLeft'} />}
                    variant={'borderless'}
                    onClick={onClickBack}
                >
                    {t('common:controls.back', 'Back')}
                </Button>
                <Text component={'h1'} variant={'h6'} weight={'semibold'}>
                    {currentAssignment.title}
                </Text>
                <Text component={'h2'} size={'small'} variant={'h6'} weight={'semibold'}>
                    {t('formative-feedback.draft-parameters', 'Formative Draft Parameters')}
                </Text>
                <Stack spacing={4}>
                    <Text variant={'p1'} weight={'medium'}>
                        {t('common:ui.instruction', 'Instruction')}
                    </Text>
                    <Text>
                        {t(
                            'formative-feedback.draft-description',
                            'To help the AI understand your work, add specific details so it can give the most accurate feedback.'
                        )}
                    </Text>
                    <FormativeForm form={form} setForm={setForm} errors={errors} />
                </Stack>
                <Button sx={{ alignSelf: 'flex-end' }} loading={isLoading} onClick={onClickSubmit}>
                    {t('common:controls.next', 'Next')}
                </Button>
            </CustomStack>
        </Container>
    );
};

const CustomStack = styled(Stack)(({ theme }) => {
    return {
        width: '100%',
        paddingBottom: theme.spacing(8),
    };
});

export default Desktop;
